import { combineReducers } from 'redux'
import { all, fork } from 'redux-saga/effects'

//import { LayoutState, layoutReducer } from './layout'

import CompanySaga from './company/sagas'
import UserSaga from './user/sagas'
import CourseSaga from './course/sagas'
import MyCourseSaga from './myCourse/sagas'
import CourseRecomSaga from './courseRecommend/sagas'
import OrdersSaga from './orders/sagas'
import CartsSaga from './cart/sagas'
import UserInfosSaga from './userInfo/sagas'

import CompanyReducer  from './company/reducer'
import userReducer from './user/reducer';
import CourseReducer  from './course/reducer'
import MyCourseReducer  from './myCourse/reducer'
import CourseRecomReducer  from './courseRecommend/reducer'
import OrdersReducer from './orders/reducer'
import CartsReducer from './cart/reducer'
import UserInfosReducer from './userInfo/reducer'
//import ProfessionalCategoryReducer from './ProfessionalCategory/reducer'
//import teamsSaga from './teams/sagas'
//import { TeamsState } from './teams/types'
//import { teamsReducer } from './teams/reducer'

// The top-level state object
export interface ApplicationState {
  //layout: LayoutState
  company: any,
  userReducer:any
  course:any
  mycourse:any
  courseRecom:any
  order:any
  cart:any
  userInfo:any
  //professionalCategory:any
  //teams: TeamsState
  //router: RouterState
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const createRootReducer = () =>
  combineReducers({
    //layout: layoutReducer,
    company: CompanyReducer,
    userReducer:userReducer,
    course:CourseReducer,
    mycourse:MyCourseReducer,
    courseRecom:CourseRecomReducer,
    order:OrdersReducer,
    cart:CartsReducer,
    userInfo : UserInfosReducer
    //professionalCategory:ProfessionalCategoryReducer
    //teams: teamsReducer,
    //router: connectRouter(history)
  })

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([
    fork(UserSaga),
    fork(CompanySaga),
    fork(CourseSaga),
    fork(MyCourseSaga),
    fork(CourseRecomSaga),
    fork(OrdersSaga),
    fork(CartsSaga),
    fork(UserInfosSaga)
  ])
}
